import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { PrimengModule } from '@modules/primeng/primeng.module';
import { TranslateModule } from '@ngx-translate/core';
import { ExpirePasswordComponent } from './expire-password/expire-password.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LoginDialogComponent } from './login-dialog/login-dialog.component';
import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './login.component';
import { RegisterExpiredComponent } from './register-expired/register-expired.component';
import { RegisterPasswordComponent } from './register-password/register-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { RegisterExpiredService } from './services/register-expired.service';
import { SisValidationSummaryComponent } from '@smartera/components';

@NgModule({
	imports: [
		CommonModule,
		LoginRoutingModule,

		PrimengModule,
		TranslateModule,
		ReactiveFormsModule,
		SisValidationSummaryComponent,
	],
	declarations: [
		LoginComponent,
		ForgotPasswordComponent,
		ExpirePasswordComponent,
		RegisterPasswordComponent,
		ResetPasswordComponent,
		LoginDialogComponent,
		RegisterExpiredComponent,
	],
	exports: [
		LoginComponent,
		ForgotPasswordComponent,
		ExpirePasswordComponent,
		ResetPasswordComponent,
		RegisterPasswordComponent,
		LoginDialogComponent,
		RegisterExpiredComponent,
	],
	providers: [RegisterExpiredService],
})
export class LoginModule {
	constructor() {
		console.log('Module - Login init.');
	}
}
